import { render, staticRenderFns } from "./InfoShow.vue?vue&type=template&id=71f5c7ae&scoped=true"
import script from "./InfoShow.vue?vue&type=script&lang=js"
export * from "./InfoShow.vue?vue&type=script&lang=js"
import style0 from "./InfoShow.vue?vue&type=style&index=0&id=71f5c7ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5c7ae",
  null
  
)

export default component.exports